<visualizer
  [testMode]="testMode"
  (isStackEvent)="isStackEvent.emit($event)"
  (isGrayscaleEvent)="isGrayscaleEvent.emit($event)">
  <!-- Custom toolbar buttons projected into the visualization toolbar (shown
       first). These are app concerns the plotting view itself doesn't own.
       The Region Editor button now lives in the library toolbar and opens the
       editor as a floating dialog. -->
  <p-button icon="pi pi-sliders-h" size="small" [text]="true"
            pTooltip="Image processing pipeline" tooltipPosition="bottom"
            (onClick)="openPipelineDialog()">
  </p-button>
</visualizer>

<app-pipeline-dialog
  [(visible)]="showPipelineDialog"
  [inputImage]="pipelineInputImage"
  [fullImageSize]="pipelineFullImageSize"
  [sourceRect]="pipelineSourceRect"
  [sourcePixelSize]="pipelineSourcePixelSize"
  (saveImage)="savePipelineResult($event)">
</app-pipeline-dialog>
